<script>
  export let title = 'Customer Demographic';
  export let countries = [];
</script>

<div class="bg-white rounded-lg border border-gray-200 p-6">
  <h3 class="text-lg font-semibold text-gray-900 mb-4">{title}</h3>

  <!-- Simple world map visualization -->
  <div class="relative bg-gradient-to-br from-blue-50 to-gray-100 rounded-lg p-8 mb-6 h-48 flex items-center justify-center">
    <div class="grid grid-cols-6 gap-4 w-full h-full">
      {#each Array(24) as _, i}
        <div
          class="bg-gray-300 rounded opacity-40 transition-all hover:opacity-70"
          style="height: {Math.random() * 60 + 20}%"
        ></div>
      {/each}
    </div>
    <div class="absolute inset-0 flex items-center justify-center">
      <div class="bg-white/90 px-6 py-3 rounded-lg shadow-sm">
        <p class="text-sm text-gray-600">Global Customer Distribution</p>
      </div>
    </div>
  </div>

  <!-- Country list -->
  <div class="space-y-3">
    {#each countries as country}
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-3">
          <span class="text-2xl">{country.flag}</span>
          <span class="text-sm font-medium text-gray-700">{country.name}</span>
        </div>
        <div class="flex items-center gap-2">
          <div class="w-24 bg-gray-200 rounded-full h-2">
            <div class="bg-blue-600 h-2 rounded-full transition-all" style="width: {country.percentage}%"></div>
          </div>
          <span class="text-sm font-medium text-gray-900 w-12 text-right">{country.percentage}%</span>
        </div>
      </div>
    {/each}
  </div>
</div>
